// extracted by mini-css-extract-plugin
export default {"form":"Content_form__S3nsA","list":"Content_list__uwCru"};